const MyShipMentTrack_Inputs = [
  {
    id: Math.random() * 10,
    name: "MyShipMentTrack",
    fields: [
      {
        id: Math.random() * 10,
        name: "Loading_Point",
        label: "Loading Point",
        type: "InputDropForQuery",
        masterName: "SearchCities",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        isRequired: true,
        autoFocus: true,
      },
      {
        id: Math.random() * 10,
        name: "Unloading_Point",
        label: "Unloading Point",
        type: "InputDropForQuery",
        masterName: "SearchCities",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Vehicle_No",
        label: "Vehicle No",
        type: "text",
        EMTQuery: {
          headers: { "X-GraphQL-Server": "secondary" },
        },
        AllCaps: true,
        spaceNotAllowed: true,
        isRequired: true,
        min: 5,
      },
      {
        id: Math.random() * 10,
        name: "Driver_Mobile",
        label: "Driver Mobile",
        type: "number",
        isRequired: true,
        min: 10,
        max: 10,
        ValidationType: "VALID_NUMBER",
      },
      {
        id: Math.random() * 10,
        name: "Track_For",
        type: "select",
        dropdowncontent: Array.from({ length: 30 }, (v, i) => `${i + 1} ${i + 1 === 1 ? "Day" : "Days"}`),
        min: 2,
        max: Infinity,
        isRequired: true,
      },
    ],
  },
];

export { MyShipMentTrack_Inputs };
